import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { uId, uAdministrator } from '../containers/App';
import getUserId from '../utils/getUserId';
import env from "react-dotenv";

let UNBLOCK_URL = `${env.API_URL}/p10/unblock`; // Correct endpoint
let DELETE_USER_URL = `${env.API_URL}/deleteProfile/admin`;

class BlockedProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      serverResponse: '',
      isProcessing: false
    };
  }

  onSubmitUnblock = async () => {
    const administrator = window.uAdministrator || uAdministrator;

    console.log('Unblock clicked, administrator:', administrator);
    console.log('Profile ID:', this.props.Id);

    if (!administrator || administrator !== 1) {
      this.setState({
        serverResponse: "Only administrators can unblock users.",
        modalIsOpen: true
      });
      return;
    }

    this.setState({ isProcessing: true });

    try {
      const response = await fetch(UNBLOCK_URL, {
        method: 'post',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': env.API_KEY
        },
        body: JSON.stringify({
          administrator: administrator,
          profile_id: this.props.Id
        })
      });

      console.log('Unblock response status:', response.status);

      if (!response.ok) {
        throw new Error('Failed to unblock user');
      }

      const data = await response.json();
      console.log('Unblock response data:', data);

      this.setState({
        serverResponse: typeof data === 'string' ? data : 'User unblocked successfully.',
        modalIsOpen: true,
        isProcessing: false
      });

      // Refresh the list
      if (this.props.setTest) {
        setTimeout(() => {
          this.props.setTest();
        }, 1000);
      }

    } catch (error) {
      console.error('Error unblocking user:', error);
      this.setState({
        serverResponse: "Error unblocking user. Please try again.",
        modalIsOpen: true,
        isProcessing: false
      });
    }
  };

  onSubmitDelete = async () => {
    const administrator = window.uAdministrator || uAdministrator;

    console.log('Delete clicked, administrator:', administrator);
    console.log('Profile ID:', this.props.Id);

    if (!administrator || administrator !== 1) {
      this.setState({
        serverResponse: "Only administrators can delete profiles.",
        modalIsOpen: true
      });
      return;
    }

    // Confirm before deleting
    if (!window.confirm('Are you sure you want to permanently delete this profile? This action cannot be undone.')) {
      return;
    }

    this.setState({ isProcessing: true });

    try {
      const response = await fetch(DELETE_USER_URL, {
        method: 'post',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': env.API_KEY
        },
        body: JSON.stringify({
          id: this.props.Id,
          administrator: administrator
        })
      });

      console.log('Delete response status:', response.status);

      if (!response.ok) {
        if (response.status === 403) {
          throw new Error('Permission denied - Admin access required');
        }
        throw new Error('Failed to delete profile');
      }

      const data = await response.json();
      console.log('Delete response data:', data);

      this.setState({
        serverResponse: typeof data === 'string' ? data : 'Profile deleted successfully.',
        modalIsOpen: true,
        isProcessing: false
      });

      // Refresh the list after successful deletion
      if (this.props.setTest) {
        setTimeout(() => {
          this.props.setTest();
          this.setState({ modalIsOpen: false });
        }, 1500);
      }

    } catch (error) {
      console.error('Error deleting profile:', error);
      this.setState({
        serverResponse: error.message || "Error deleting profile. Please try again.",
        modalIsOpen: true,
        isProcessing: false
      });
    }
  };

  render() {
    const { modalIsOpen, serverResponse, isProcessing } = this.state;
    const administrator = window.uAdministrator || uAdministrator;

    return (
      <>
        <div className="blocked-profile-actions">
          {/* Unblock Button */}
          <button
            onClick={this.onSubmitUnblock}
            disabled={isProcessing}
            className="action-button unblock-button"
          >
            {isProcessing ? (
              <>
                <div className="button-spinner"></div>
                <span>Processing...</span>
              </>
            ) : (
              <span>Unblock</span>
            )}
          </button>

          {/* Delete Account Link - Only show for admins */}
          {administrator === 1 && (
            <button
              onClick={this.onSubmitDelete}
              disabled={isProcessing}
              className="action-link delete-link"
            >
              Delete Account
            </button>
          )}
        </div>

        {/* Modern Modal */}
        {modalIsOpen && (
          <div className="modal-overlay" onClick={() => this.setState({ modalIsOpen: false })}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className={`modal-icon ${serverResponse.includes('Error') || serverResponse.includes('not') ? 'error-icon' : ''}`}>
                {serverResponse.includes('Error') || serverResponse.includes('not') ? (
                  <svg className="error-mark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg className="checkmark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <h3 className="modal-title">
                {serverResponse.includes('Error') || serverResponse.includes('not') || serverResponse.includes('Permission') ? 'Error' : 'Success!'}
              </h3>
              <p className="modal-message">{serverResponse}</p>
              <button 
                onClick={() => this.setState({ modalIsOpen: false })} 
                className="modal-close-btn"
              >
                Close
              </button>
            </div>
          </div>
        )}

        <style>{`
          .blocked-profile-actions {
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 100%;
            margin-top: 12px;
          }

          .action-button {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 10px 16px;
            border-radius: 8px;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s;
            border: none;
          }

          .unblock-button {
            background: linear-gradient(135deg, #10b981, #059669);
            color: white;
            box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
          }

          .unblock-button:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
          }

          .unblock-button:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .action-link {
            background: transparent;
            border: none;
            color: #dc2626;
            font-size: 13px;
            font-weight: 600;
            padding: 8px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .action-link:hover:not(:disabled) {
            color: #991b1b;
            text-decoration: underline;
          }

          .action-link:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .button-spinner {
            width: 16px;
            height: 16px;
            border: 2px solid white;
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 0.6s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: blur(4px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            padding: 16px;
            animation: fadeIn 0.2s;
          }

          .modal-content {
            background: white;
            border-radius: 20px;
            padding: 32px;
            max-width: 400px;
            width: 100%;
            text-align: center;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
            animation: zoomIn 0.2s;
          }

          .modal-icon {
            width: 64px;
            height: 64px;
            background: linear-gradient(135deg, #34d399, #10b981);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 20px;
          }

          .modal-icon.error-icon {
            background: linear-gradient(135deg, #ef4444, #dc2626);
          }

          .checkmark,
          .error-mark {
            width: 32px;
            height: 32px;
            color: white;
          }

          .modal-title {
            font-size: 24px;
            font-weight: bold;
            color: #111827;
            margin: 0 0 12px 0;
          }

          .modal-message {
            color: #6b7280;
            margin: 0 0 24px 0;
            line-height: 1.5;
          }

          .modal-close-btn {
            width: 100%;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 12px;
            font-weight: 600;
            font-size: 15px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .modal-close-btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes zoomIn {
            from {
              transform: scale(0.95);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}</style>
      </>
    );
  }
}

export default withRouter(BlockedProfile);